import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useSession } from '../platform/session.tsx';
import { enabledModules } from './modules.ts';
import type { WebModule } from './types.ts';

const ModulesContext = createContext<WebModule[]>([]);

/** Modules enabled for this deployment, as reported by the server at sign-in. */
export function ModulesProvider({ children }: { children: ReactNode }) {
  // Keyed by the list's contents: /me is refetched often, but the module list rarely changes.
  const key = (useSession().me?.features.disabledModules ?? []).join(',');
  const modules = useMemo(() => enabledModules(key ? key.split(',') : []), [key]);
  return <ModulesContext.Provider value={modules}>{children}</ModulesContext.Provider>;
}

export function useModules(): WebModule[] {
  return useContext(ModulesContext);
}
